import { render, staticRenderFns } from "./type5.vue?vue&type=template&id=2f602678&scoped=true&"
import script from "./type5.vue?vue&type=script&lang=js&"
export * from "./type5.vue?vue&type=script&lang=js&"
import style0 from "./type5.vue?vue&type=style&index=0&id=2f602678&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f602678",
  null
  
)

export default component.exports